// extracted by mini-css-extract-plugin
export default {"root":"MoreOptionsCard-module__root___3s4Py"};